import { render, staticRenderFns } from "./PartCard.vue?vue&type=template&id=19bb6508&"
import script from "./PartCard.vue?vue&type=script&lang=js&"
export * from "./PartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports